import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/commissioner/400.css';
import '@fontsource/commissioner/600.css';
import '@fontsource/commissioner/800.css';
import '@fontsource/atkinson-hyperlegible/400.css';
import '@fontsource/atkinson-hyperlegible/700.css';
import './styles/tokens.css';
import App from './App';
import { installSTTModeConsoleHelper } from './speech';

// Expose window.sttMode.get()/set('native'|'gcp') in the browser console so the
// STT provider mode can be switched without curl (both drive the same backend
// /stt/mode setting).
installSTTModeConsoleHelper();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
